export class ListSparkEnginesFilterConditions {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "IdFilters",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "StringFilters",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "SparkEngineStatusFilters",
            "format": ""
        },
        {
            "name": "credentialsProfileId",
            "baseName": "credentialsProfileId",
            "type": "IdFilters",
            "format": ""
        },
        {
            "name": "eonSparkVersion",
            "baseName": "eonSparkVersion",
            "type": "StringFilters",
            "format": ""
        },
        {
            "name": "instanceFamily",
            "baseName": "instanceFamily",
            "type": "StringFilters",
            "format": ""
        },
        {
            "name": "dedicatedResources",
            "baseName": "dedicatedResources",
            "type": "BooleanFilters",
            "format": ""
        },
        {
            "name": "useSpot",
            "baseName": "useSpot",
            "type": "BooleanFilters",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListSparkEnginesFilterConditions.attributeTypeMap;
    }
    constructor() {
    }
}
